import type { ReactNode } from 'react';

export interface PageHeaderProps {
  breadcrumb: string;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ breadcrumb, title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className="mb-7 flex items-start justify-between gap-6">
      <div>
        <div className="mb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-foreground/50">
          {breadcrumb}
        </div>
        <h1 className="font-heading text-[28px] font-bold leading-tight tracking-tight m-0">
          {title}
        </h1>
        {subtitle ? (
          <div className="mt-1 text-[13px] text-foreground/60 max-w-2xl">{subtitle}</div>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-3">{actions}</div> : null}
    </div>
  );
}
